import type { TestConfig } from 'yup';
import { useWohInputStore } from '@/features/Sparten/woh/useInputStore';

export const isDateAfterBaujahr: TestConfig<number | undefined> = {
  name: 'isValidDate',
  message: 'Darf nicht vor dem Baujahr liegen.',
  test(val) {
    if (val === undefined) return true;

    return val >= useWohInputStore().baujahr;
  },
};
